(function () {
    'use strict';

    angular.module('app').component('clinicPanelDashboardAverageSubmissionTimeComponent', {
        templateUrl: require('/App/clinic/views/panelDashboard/averageSubmissionTime/averageSubmissionTime.component.html'),
        controller: ['$uibModal', 'abp.services.app.panelDashboard', controller],
        controllerAs: 'vm',
        bindings: {
            panelLocationId: '<',
            isGpPanel: '<'
        }
    });

    function controller($uibModal, panelDashboardSvc) {
        var vm = this;

        vm.$onChanges = onChanges;
        vm.onTable = onTable;

        vm.header = App.localize('AverageSubmissionTime');
        vm.growthDuration = App.localize('FromSameDayLastMonth');
        vm.tooltip = App.localize('AverageSubmittedTimeTooltip');
        vm.hasGpDashboardEnhancement = abp.setting.getBoolean('Hms.Feature.GPDashboardEnhancement');

        function onChanges(changes) {
            if (changes.panelLocationId && changes.panelLocationId.currentValue) {
                getAverageSubmissionTimeMetric();
            }
        }

        function getAverageSubmissionTimeMetric() {
            vm.loading++;
            panelDashboardSvc.getAverageSubmissionTimeMetric({ id: vm.panelLocationId })
                .success(function (data) {
                    vm.metrics = data.metrics;
                    vm.growthRate = data.growthRate;
                    vm.momGrowthResult = data.momGrowthRate;
                })
                .finally(function () {
                    vm.loading--;
                });
        }

        function onTable() {
            $uibModal.open({
                component: 'clinicPanelDashboardGrowthTable',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    result: function () {
                        return vm.momGrowthResult;
                    },
                    type: function () {
                        return "averageSubmissionTime";
                    },
                    header: function () {
                        return vm.header;
                    }
                }
            });
        }
    }
})();
